import React from "react";
import { useNavigate } from "react-router-dom";
import "./AppHome.css";

export default function WelcomePage() {
  const navigate = useNavigate();

  return (
    <div className="welcome-container2">
      <div className="welcome-Regi-card">
        <div className="icon-circle">✓</div>

        <h1>Welcome to Life Fitness Partner!</h1>
        <p>Your registration was successfully completed.</p>


      </div>
    </div>
  );
}
